/**
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';

/**
 * Zone JS is required by Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.
import './global-shim';

// @ts-expect-error
window.__importDefault = (mod) => (mod && mod.__esModule ? mod : { default: mod });
